import { TranslateProcessor } from '@opm/hooks/useTranslateConfig';
import { categoryTranslateV2 } from '@opm/hooks/useTranslateConfig/utils';
import { getLocale } from 'umi';

/**
 * CompetitorsAdCreatives 翻译处理器
 *
 * 将 FilterCommon 的 backCondConfig 回调返回的 cond 数据
 * 转换为翻译方法集合，供页面内子组件使用
 */
export const createAdCreativesProcessor = (): TranslateProcessor => {
  return cond => {
    // 处理类型配置
    const typeList = (cond?.materials_config_types || []).map((item: any) => ({
      text: item.label_en,
      textCn: item.label_zh,
      value: item.value,
    }));

    return {
      translateType: categoryTranslateV2(typeList, getLocale),
    };
  };
};

// 导出默认处理器实例
export const adCreativesProcessor = createAdCreativesProcessor();
